/* eslint-disable no-comments/disallowComments */
/* eslint-disable max-lines */
import { Inject, Injectable, Renderer2 } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { RegistrationFactory } from './registration.factory';
import { AdditionalLocationListResponse, BusinessRegistrationFlowSubmitModalLabels, CompanyDetailsSection, DealerData, GridData, LocationList, RegistrationResponse, RegistrationState, SaveBusinessAccountResponse, SaveUserPayload, SubmitBusinessPayload, SubmitRegistrationResponse } from './definitions';
import { ApiService } from '../../services/api/api.service';
import { ApiResponse } from '../../definitions/api-response.interface';
import { KngFooterState, ModalState } from 'kinetic-angular';
import { EnvironmentRef } from 'projects/tmhna-portal/src/environments/interfaces';
import { expEnvironmentRef } from '../../injection-tokens/environment.injection-token';
import { HttpErrorResponse } from '@angular/common/http';
import { LoggerService } from '../../services/logger/logger.service';
import { Router } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { has as lodashHas, set as lodashSet, noop as lodashNoop, get as lodashGet } from 'lodash';
import { ApplicationPath, BooleanValues, ButtonPosition, ButtonSize, ButtonStyle, CountryCode, CssClass, ErrorMessage, FileName, Icons, IsRequestSubmittedForReview, RegistrationStatus, UserType, states, TermsAndConditionPrivacyPolicyInfoBannerText } from '../../services/shared/shared-enums';
import { SharedService } from '../../services/shared/shared.service';
import { AemApiService } from '../../services/api/api.aem.service';
import { UserRegistrationStatus, UserRegistrationStatusValue } from '../../services/api/definitions';
import { RoutingFunction } from '../auth';
import { SharedUtilService } from '../../services/shared/shared-util.service';
import { ToastrService } from 'ngx-toastr';
import { VerifiedAddressSuggestion, LocationAddress } from '../../services/shared/shared-interface';
import { RegistrationUtilService } from './registration-util.service';
import { RegistrationMappingFactory } from './registration-mapping-factory';
import { KngUploadFileFactory, KngUploadFileState } from 'projects/kinetic-angular/src/lib/components/upload-file';
import { ErrorMessageHeading, ErrorMessageSubHeading } from 'projects/kinetic-angular/src/lib/components';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { AnalyticsDataLayer } from '../../services/analytics/definitions';
import { companyAdminRoleId } from '../../services/shared/shared-constants';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';
@Injectable({
	providedIn: 'root'
})
export class RegistrationService
{
	public state$: BehaviorSubject<RegistrationState> = new BehaviorSubject<RegistrationState>(RegistrationFactory.build());
	checkAll: boolean = false;
	isPrimaryLocationPresent: boolean = false;
	downloadTemplateError: boolean = false;
	isIndividualUser: boolean = false;
	verifyAddressState: ModalState = RegistrationFactory.verifyAddressModal();
	verifyRoleModalState: ModalState = RegistrationFactory.verifyAddressModal();
	preFilledCompanyDetails!: CompanyDetailsSection;
	vertexFailedWithNoSuggestedAddress: boolean = false;
	isRequestedRoleValid: boolean = false;
	get state(): RegistrationState
	{
		return this.state$.value;
	}
	get stateChanged(): Observable<RegistrationState>
	{
		return this.state$.asObservable();
	}
	set isSavingIndividualUser(val: boolean)
	{
		this.isIndividualUser = val;
	}
	get isSavingIndividualUser()
	{
		return this.isIndividualUser;
	}
	get isRaymond(): boolean | undefined
	{
		return this.environmentRef.isRaymond;
	}
	private readonly eventCallback = new Subject<string>();
	eventCallback$ = this.eventCallback.asObservable();
	public statesOrProvinces$: BehaviorSubject<{label: string; value: string}[]> = new BehaviorSubject<{label: string; value: string}[]>(states);
	public profileInformationForm: FormGroup = this.fb.group({});
	public companyDetailsForm: FormGroup = this.fb.group({});
	public companyInfoNotFound: boolean = false;
	public validUserSuccess: boolean = false;
	public prefillDetailsSuccess: boolean = false;
	addressState!: string;
	verifiedLocation!: LocationAddress;
	verifiedAddress!: VerifiedAddressSuggestion;
	formattedPostalCode: string = '';
	showModifyButton: boolean = false;
	isModifyButtonClicked: boolean = false;
	addressSuggestion: boolean = false;
	useVerifiedAddress: boolean = false;
	userType: string = '';
	isTCSection: boolean = false;
	isSubmitRegistrationButton: boolean = false;
	isContinueButton: boolean = false;
	isContinueSuccess: boolean = false;
	isUploadSuccess: boolean = false;
	additionalLocations: LocationList[] = [];
	termsandPrivacyAgreed: boolean = false;
	disableDomainClaim:boolean = false;
	businessRegistrationFlowSubmitModalState: ModalState = RegistrationFactory.businessRegistrationFlowSubmitModal();
	businessRegistrationUploadListModalState:ModalState= RegistrationFactory.businessRegistrationUploadListModal();
	uploadFileState: KngUploadFileState = KngUploadFileFactory.build();
	public stateValue = states;
	constructor(
		public apiService: ApiService, public aemApiService: AemApiService, private readonly loggerService: LoggerService, private readonly sharedUtilService: SharedUtilService, public router: Router, private readonly fb: FormBuilder,
		@Inject(expEnvironmentRef) private readonly environmentRef: EnvironmentRef, public sharedService: SharedService, private readonly toaster: ToastrService, private readonly registrationUtilService: RegistrationUtilService,
		private readonly analyticsService: AnalyticsService, private readonly localStorageService: LocalStorageService
	) { }
	public updateState(value: RegistrationState): void
	{
		this.state$.next(value);
	}
	downloadButtonState = this.sharedUtilService.getButtonState(ButtonSize.medium, ButtonStyle.secondary, '', false, { altText: '', iconPath: '' }, ButtonPosition.left);
	public form(): void
	{
		this.profileInformationForm = this.fb.group({
			firstName: [
				{ value: this.state.firstName, disabled: false },
				[ Validators.required, this.sharedService.requiredLength ]
			],
			lastName: [
				{ value: this.state.lastName, disabled: false },
				[ Validators.required, this.sharedService.requiredLength ]
			],
			email: [{ value: this.state.email, disabled: true }, Validators.required ],
			phoneNumber: [
				{ value: this.state.phoneNumber, disabled: false },
				[ Validators.required, this.sharedService.validateStringUnique, this.sharedService.validatePhoneSequence, this.sharedService.minLength ]
			],
			jobTitle: [{ value: this.state.profileInformation.job, disabled: false }, Validators.required ],
			requestedRole: [{ value: this.state.profileInformation.role?this.state.profileInformation.role:companyAdminRoleId, disabled: false }, Validators.required ]
		});
		this.companyDetailsForm = this.fb.group({
			accountName: [
				{ value: this.state.accountName, disabled: false },
				[ Validators.required,
					(c: AbstractControl) => this.sharedService.alphaSpecialCharValidation(c, 'accountName')  ]
			],
			addressLine1: [{ value: this.state.addressDetails.addressLine1, disabled: false }, [ Validators.required, this.sharedService.requiredLength ] ],
			addressLine2: [{ value: this.state.addressDetails.addressLine2, disabled: false }],
			country: [{ value: this.state.addressDetails.country? this.state.addressDetails.country : CountryCode.unitedStatesofAmerica, disabled: false }, [ Validators.required, this.sharedService.requiredLength ] ],
			city: [{ value: this.state.addressDetails.city, disabled: false }, [ Validators.required,
				(c: AbstractControl) => this.sharedService.alphaSpecialCharValidation(c, 'city') ] ],
			state: [{ value: this.state.addressDetails.state, disabled: false }, [ Validators.required, this.sharedService.requiredLength ] ],
			postalCode: [{ value: this.state.addressDetails.zipCode, disabled: false }, [ Validators.required, this.sharedService.requiredLength ] ]
		});
		if(this.companyDetailsForm.controls['accountName'].value !== '')
		{
			this.companyDetailsForm.controls['accountName'].markAsDirty();
		}
	}
	public getFooterData(): void
	{
		this.aemApiService.getFooterData().subscribe((res: ApiResponse) =>
		{
			if(this.isRaymond) 
			{
				this.state.footer = <KngFooterState>res.data;

				this.state.footer.ribbonImage =  '/assets/images/raymondFooterRibbon.png';
			}
			else 
			{
				const data = res.data as { unifiedFooter: string; css: { ecomm: string }; script: {} };
				this.state.footer.footercontent.unifiedFooter = data.unifiedFooter;
				this.state.footer.footercontent.css.ecomm = data.css?.ecomm;
				this.state.footer.footercontent.script = data.script;
				this.aemApiService.loadFooterScripts(this.state.footer.footercontent.script);
				this.aemApiService.loadFooterStyles(this.state.footer.footercontent.css.ecomm);
			}
			
			this.updateState(this.state);
		});
	}
	pageLoadHandler()
	{
		setTimeout(() => { this.state.loading = !(this.validUserSuccess && this.prefillDetailsSuccess); }, 1000);
	}
	public getUserData()
	{
		this.apiService.getPrefilledUserData().subscribe({
			next: (res: ApiResponse) =>
			{
				this.state.jobTitle = [];
				const responseObject: RegistrationState = <RegistrationState>res.data;
				responseObject.companyDetails.country = this.sharedService.checkCountryCode(responseObject.companyDetails.country);
				this.state.tempFlag = responseObject.tempIsPrefilled;
				this.state.crmPrefill = responseObject.crmPrefill;
				this.preFilledCompanyDetails = responseObject.companyDetails;
				this.state.accountName = (responseObject.companyDetails.companyName.replace(/\u00A0/g, ' '));
				this.state.addressDetails = this.registrationUtilService.mapAddress(this.state.addressDetails, responseObject.companyDetails);
				this.state.phoneNumber = this.sharedService.formatPhoneNumber(responseObject.profileInformation.phoneNumber);
				setTimeout(()=>
	 			{
					this.state.jobTitle = responseObject.profileInformation.jobTitle;
				}, 0);
				this.state.requestedRole = responseObject.profileInformation.requestedRole;
				this.state.requestedRole = this.sharedService.checkForIndividualUserRole(this.state.requestedRole);
				this.state.profileInformation.role = responseObject.profileInformation.role;
				this.state.profileInformation.job = responseObject.profileInformation.job;

				this.form();
				if(this.state.addressDetails.country)
				{
					this.statesOrProvinces$.next(this.registrationUtilService.getStateProvinceValues(this.state.addressDetails.country));
				}
				this.updateState(this.state);
				this.prefillDetailsSuccess = true;
				this.pageLoadHandler();
			},
			error: (error: HttpErrorResponse) =>
			{
				this.prefillDetailsSuccess = true;
				this.pageLoadHandler();
				this.loggerService.log(error.error.message);
			}
		});
		const values = Object.values(localStorage);
		for (const value of values)
		{
			if (value.includes('idTokenClaims'))
			{
				const parsedVal = JSON.parse(value);
				!lodashHas(parsedVal, 'idTokenClaims.emails') ? lodashSet(parsedVal, 'idTokenClaims.emails', [lodashGet(parsedVal, 'idTokenClaims.email', '')]) : lodashNoop();
				this.state.companyDetails.companyName = parsedVal.idTokenClaims.extension_CompanyName;
				this.state.firstName = parsedVal.idTokenClaims.given_name;
				this.state.lastName = parsedVal.idTokenClaims.family_name;
				this.state.email = parsedVal.idTokenClaims.emails[0];
				this.updateState(this.state);
			}
		}
		this.registrationUtilService.trackAnalyticsEvent({
			event: 'pageView',
			page: {
				name: 'registration:complete your profile'
			}
		}, this.state.email);
	}
	public verifyInformation(payload: SaveUserPayload, element: HTMLDivElement)
	{
		if(!this.state.crmPrefill)
		{
			payload.crmPrefill = false;
		}
		if(this.state.crmPrefill)
		{
			payload = this.checkForCompanyDetailsChange(payload);
		}
		this.apiService.saveUserData(payload).subscribe({
			next: (response: ApiResponse) =>
			{
				this.addressSuggestion = false;
				this.companyInfoNotFound = false;
				this.vertexFailedWithNoSuggestedAddress = false;
				if (response.data && (response.statusCode === 200 || response.statusCode === 201))
				{	
					this.showVerifyRoleModal(response);
					this.successVerifyScenario(response, element);
					const analyticsData: AnalyticsDataLayer = {
						event: 'VerifyInformation Success',
						link: {
							name: 'Verify Information button'
						}
					};
					this.analyticsService.trackRegistrationByEvent(analyticsData, this.state.email);
				}
				if (response.data && response.statusCode === 206)
				{
					this.showModifyButton = false;
					this.isModifyButtonClicked = false;
					this.isTCSection = false;
					this.vertexApiValidation(response);
				}
			},
			error: (error: HttpErrorResponse) =>
			{
				this.eventCallback.next(error.error);
				this.vertexFailedWithNoSuggestedAddress = false;
				this.registrationUtilService.trackAnalyticsForRegistrationError(error.error.message, this.state.email);
			}
		});
	}


	submitRegistrationReviewOrCancel(payload:SaveUserPayload)
	{
		this.apiService.submitRegistrationReviewOrCancel(payload).subscribe({
			next: (response: ApiResponse) =>
			{
				if(response)
				{
					localStorage.setItem(IsRequestSubmittedForReview.isRequestSubmittedForReview, BooleanValues.true);
					this.router.navigate(['confirmation']);
			    }
			},
			error: (error: HttpErrorResponse) =>
			{
				this.state.loading = false;
				this.handleError(error);
				this.registrationUtilService.trackAnalyticsForRegistrationError(error.error.message, this.state.email);

			}
		});
	}
	checkForCompanyDetailsChange(payload: SaveUserPayload)
	{
		if(this.checkForCompanyDetailsMandatoryFields(payload) || (payload?.addressLine2!==null && payload?.addressLine2!==this.preFilledCompanyDetails?.addressLine2))
		{
			payload.crmPrefill = false;
			return payload;
		}
		else
		{
			payload.crmPrefill = true;
			return payload;
		}
	}
	checkForCompanyDetailsMandatoryFields(payload: SaveUserPayload): boolean
	{
		const isPostalCodeUpdated = this.checkForPostalCodeUpdate(payload?.postalCode, this.preFilledCompanyDetails?.zipCode);
		if(payload?.addressLine1!==this.preFilledCompanyDetails?.addressLine1 || payload?.city!==this.preFilledCompanyDetails?.city ||
			payload?.country!==this.preFilledCompanyDetails?.country || payload?.state!==this.preFilledCompanyDetails?.state || isPostalCodeUpdated)
		{
			return true;
		}
		else
		{
			return false;
		}
	}
	checkForPostalCodeUpdate(payloadPostalCode: string, preFilledPostalCode: string): boolean
	{
		preFilledPostalCode = this.preFilledCompanyDetails?.country === CountryCode.unitedStatesofAmerica ?
			preFilledPostalCode.replace(/[^\d]/g, '') : preFilledPostalCode;

		if(payloadPostalCode.trim() !== preFilledPostalCode.trim())
		{
			return true;
		}
		return false;
	}
	handleError(error: HttpErrorResponse)
	{
		this.useVerifiedAddress = false;
		this.addressSuggestion = false;
		this.companyInfoNotFound = false;
		if (Array.isArray(error.error.message))
		{
			this.toaster.error(error.error.message[0]);
			return;
		}
		this.toaster.error(error.error.message ? error.error.message : 'Something went wrong, please try again');
	}
	successVerifyScenario(response: ApiResponse, element: HTMLDivElement)
	{
		const data: DealerData = response.data as DealerData;
		const error: string | undefined = data.errorMessage;

		if (data.requestType && this.isRequestedRoleValid)
		{
			this.showModifyButton = true;
			this.state.verifyInformationButton.disabled = true;
			this.isModifyButtonClicked = false;
			this.state.loading = false;
			this.addressSuggestion = false;
			this.companyInfoNotFound = false;
			this.profileInformationForm.controls['jobTitle'].disable({ emitEvent: true, onlySelf: false });
			this.profileInformationForm.controls['requestedRole'].disable({ emitEvent: true, onlySelf: false });
			this.companyDetailsForm.controls['state'].disable({ emitEvent: true, onlySelf: false });
			this.companyDetailsForm.controls['country'].disable({ emitEvent: true, onlySelf: false });
			this.checkNextStepByUserType(data);
		}
		else if (error)
		{
			this.handleVerifyInfoError(data, element);
		}
	}
	checkNextStepByUserType(data: DealerData)
	{
		if(data.requestType === UserType.generalUser)
		{
			this.userType = UserType.generalUser;
			this.displayTCSectionWithSubmitButton();
		}
		else if(data.requestType === UserType.individualUser)
		{
			this.userType = UserType.individualUser;
			this.displayTCSectionWithSubmitButton();
		}
		else if(data.requestType === UserType.businessAdminUser)
		{
			this.userType = UserType.businessAdminUser;
			this.displayTCSectionWithSubmitButton();
        	this.isContinueButton = true;
        	this.isSubmitRegistrationButton = false;
		}
	}
	displayTCSectionWithSubmitButton()
	{
		this.isTCSection = true;
		this.isSubmitRegistrationButton = true;
	}
	handleVerifyInfoError(data: DealerData, element: HTMLDivElement)
	{
		this.state.dealerInfo = data.dealerInfo;
		this.companyInfoNotFound = true;
		this.loggerService.log('Company Not Found Error');
		this.state.loading = false;
		this.addressSuggestion = false;
		this.showModifyButton = false;
		this.state.verifyInformationButton.disabled = false;
		this.isModifyButtonClicked = false;
		if (this.companyInfoNotFound)
		{
			this.state.loading = false;
			this.registrationUtilService.showContactDealer(element, this.state.email);
			this.useVerifiedAddress = false;
			this.isTCSection = false;
			this.isSubmitRegistrationButton = false;
			this.companyDetailsForm.controls['country'].enable();
			this.companyDetailsForm.controls['state'].enable();
		}
	}
	vertexApiValidation(response: ApiResponse)
	{
		this.verifiedAddress = response.data as VerifiedAddressSuggestion;
		this.state.loading = false;

		if (this.verifiedAddress.verifiedLocation !== undefined)
		{
			this.statesOrProvinces$.next(this.registrationUtilService.getStateProvinceValues(this.verifiedAddress.verifiedLocation.country ?? ''));
			this.addressSuggestion = true;
			this.vertexFailedWithNoSuggestedAddress = false;
			this.useVerifiedAddress = true;
			this.formattedPostalCode = this.formatZipCode(this.verifiedAddress.verifiedLocation.postalCode);
			this.companyDetailsForm.patchValue({
				addressLine1: this.verifiedAddress.verifiedLocation.addressLine1,
				addressLine2: this.verifiedAddress.verifiedLocation.addressLine2 ? this.verifiedAddress.verifiedLocation.addressLine2 : '',
				city: this.verifiedAddress.verifiedLocation.city,
				state: this.verifiedAddress.verifiedLocation.state,
				country: this.verifiedAddress.verifiedLocation.country,
				postalCode: this.formattedPostalCode
			});
			this.companyDetailsForm.controls['addressLine2'].reset();
			this.companyDetailsForm.controls['country'].disable({ emitEvent: true, onlySelf: false });
			this.companyDetailsForm.controls['state'].disable({ emitEvent: true, onlySelf: false });
			this.verifiedLocation = this.verifiedAddress.verifiedLocation;
			this.statesOrProvinces$.value.forEach(element =>
			{
				if (this.verifiedAddress.verifiedLocation?.state === element.value)
				{
					this.addressState = element.label;
				}
			});
		}
		else
		{
			this.addressSuggestion = true;
			this.vertexFailedWithNoSuggestedAddress = true;
			this.useVerifiedAddress = false;
			this.companyDetailsForm.controls['country'].enable();
			this.companyDetailsForm.controls['state'].enable();
			this.registrationUtilService.trackAnalyticsForRegistrationError(this.verifiedAddress.errorMessage, this.state.email);
		}
	}
	public formatZipCode(value: string): string
	{
		return this.sharedUtilService.formatZipCode(value, this.companyDetailsForm.controls['country']['value']).trim();
	}
	public addLabelsToForm()
	{
		this.apiService.getRegistrationFormLabels().subscribe({
			next: (response) =>
			{
				const data = response.data as RegistrationResponse;
				if(data)
				{
					this.mapRegistrationPageCompanyDetails(data);
					this.mapRegistrationPageCompanyError(data);
					this.mapRegistrationPageProfileInfo(data);
					this.mapRegistrationPageTermsAndConditions(data);
					this.mapRegistrationPagePrivacyPolicy(data);
					this.mapRegistrationPageAdditionalLocation(data);
					this.mapDomainAemLabels(data);
					this.state.registrationPage.logo.altText = this.sharedService.emptyStringHandler(data['registration-page'].logo?.altText);
					this.state.registrationPage.logo.iconPath = this.sharedService.emptyStringHandler(data['registration-page'].logo?.iconPath);
					this.state.registrationPage.logoutLabel = this.sharedService.emptyStringHandler(data['registration-page'].logoutLabel);
					this.state.registrationPage.pageDescription = this.sharedService.emptyStringHandler(data['registration-page'].pageDescription);
					this.state.registrationPage.pageHeading = this.sharedService.emptyStringHandler(data['registration-page'].pageHeading);
					this.state.registrationPage.stepLabel = this.sharedService.emptyStringHandler(data['registration-page'].stepLabel);
					this.state.registrationPage.submitButton = this.sharedService.emptyStringHandler(data['registration-page'].submitButton);
					this.state.termsModal.label = data['registration-page'].termsConditions?.terms?.modal?.heading;
					this.state.additionalLocationGridHeaderDesktop = [];
					this.state.additionalLocationGridHeaderDesktop.push( data['registration-page'].additionalLocation?.selectLocationTableHeader?.companyName);
					this.state.additionalLocationGridHeaderDesktop.push( data['registration-page'].additionalLocation?.selectLocationTableHeader?.address);
					this.state.additionalLocationGridHeaderDesktop.push( data['registration-page'].additionalLocation?.selectLocationTableHeader?.country);
					this.mapAdditionalAemLabels();
				}
			},
			error: (e: HttpErrorResponse) => this.loggerService.log(e.error.message),
			complete: () =>
			{
				this.loggerService.log('Received Labels from AEM');
			}
		});
	}
	mapRegistrationPageCompanyDetails(data:RegistrationResponse)
	{
		this.state.registrationPage.companyDetails.addressLine1 = this.sharedService.emptyStringHandler(data['registration-page'].companyDetails?.addressLine1);
		this.state.registrationPage.companyDetails.addressLine2 = this.sharedService.emptyStringHandler(data['registration-page'].companyDetails?.addressLine2);
		this.state.registrationPage.companyDetails.address2OptionalLabel = this.sharedService.emptyStringHandler(data['registration-page'].companyDetails?.address2OptionalLabel);
		this.state.registrationPage.companyDetails.city = this.sharedService.emptyStringHandler(data['registration-page'].companyDetails?.city);
		this.state.registrationPage.companyDetails.companyName = this.sharedService.emptyStringHandler(data['registration-page'].companyDetails?.companyName);
		this.state.registrationPage.companyDetails.description = this.sharedService.emptyStringHandler(data['registration-page'].companyDetails?.description);
		this.state.registrationPage.companyDetails.heading = this.sharedService.emptyStringHandler(data['registration-page'].companyDetails?.heading);
		this.state.registrationPage.companyDetails.logo.altText = this.sharedService.emptyStringHandler(data['registration-page'].companyDetails?.logo?.altText);
		this.state.registrationPage.companyDetails.logo.iconPath = this.sharedService.emptyStringHandler(data['registration-page'].companyDetails?.logo?.iconPath);
		this.state.registrationPage.companyDetails.country = this.sharedService.emptyStringHandler(data['registration-page'].companyDetails?.country);
		this.state.registrationPage.companyDetails.state = this.sharedService.emptyStringHandler(data['registration-page'].companyDetails?.state);
		this.state.registrationPage.companyDetails.stateAltText = this.sharedService.emptyStringHandler(data['registration-page'].companyDetails?.stateAltText);
		this.state.registrationPage.companyDetails.stepNumber = this.sharedService.emptyStringHandler(data['registration-page'].companyDetails?.stepNumber);
		this.state.registrationPage.companyDetails.zipCode = this.sharedService.emptyStringHandler(data['registration-page'].companyDetails?.zipCode);
		this.state.registrationPage.companyDetails.companyNotFoundErrorModalDescription = this.sharedService.emptyStringHandler(data['registration-page'].companyDetails?.companyNotFoundErrorModalDescription);
		this.state.registrationPage.companyDetails.companyNotFoundErrorModalHeader = this.sharedService.emptyStringHandler(data['registration-page'].companyDetails?.companyNotFoundErrorModalHeader);

	}
	mapRegistrationPageCompanyError(data:RegistrationResponse)
	{
		this.state.registrationPage.companyError.messageMain = this.sharedService.emptyStringHandler(data['registration-page'].companyError?.messageMain);
		this.state.registrationPage.companyError.messageSub = this.sharedService.emptyStringHandler(data['registration-page'].companyError?.messageSub);
		this.state.registrationPage.companyError.actionMessage = this.sharedService.emptyStringHandler(data['registration-page'].companyError?.actionMessage);
		this.state.registrationPage.companyError.phoneNumber.label = this.sharedService.emptyStringHandler(data['registration-page'].companyError?.phoneNumber?.label);
		this.state.registrationPage.companyError.phoneNumber.value = this.sharedService.emptyStringHandler(data['registration-page'].companyError?.phoneNumber?.value);
		this.state.registrationPage.companyError.email.label = this.sharedService.emptyStringHandler(data['registration-page'].companyError?.email.label);
		this.state.registrationPage.companyError.email.value = this.sharedService.emptyStringHandler(data['registration-page'].companyError?.email.value);
		this.state.registrationPage.companyError.customerServiceName = this.sharedService.emptyStringHandler(data['registration-page'].companyError?.customerServiceName);
		this.state.registrationPage.companyError.address = this.sharedService.emptyStringHandler(data['registration-page'].companyError?.address);
		this.state.registrationPage.companyError.contactDealer.icon = this.sharedService.emptyStringHandler(data['registration-page'].companyError?.contactDealer?.icon);
		this.state.registrationPage.companyError.contactDealer.label = this.sharedService.emptyStringHandler(data['registration-page'].companyError?.contactDealer?.label);
	}
	mapRegistrationPageProfileInfo(data:RegistrationResponse)
	{
		this.state.registrationPage.profileInfo.description = this.sharedService.emptyStringHandler(data['registration-page'].profileInfo?.description);
		this.state.registrationPage.profileInfo.emailAddress = this.sharedService.emptyStringHandler(data['registration-page'].profileInfo?.emailAddress);
		this.state.registrationPage.profileInfo.firstName = this.sharedService.emptyStringHandler(data['registration-page'].profileInfo?.firstName);
		this.state.registrationPage.profileInfo.heading = this.sharedService.emptyStringHandler(data['registration-page'].profileInfo?.heading);
		this.state.registrationPage.profileInfo.jobTitle = this.sharedService.emptyStringHandler(data['registration-page'].profileInfo?.jobTitle);
		this.state.registrationPage.profileInfo.jobTitleAltText = this.sharedService.emptyStringHandler(data['registration-page'].profileInfo?.jobTitleAltText);
		this.state.registrationPage.profileInfo.lastName = this.sharedService.emptyStringHandler(data['registration-page'].profileInfo?.lastName);
		this.state.registrationPage.profileInfo.logo.iconPath = this.sharedService.emptyStringHandler(data['registration-page'].profileInfo?.logo?.iconPath);
		this.state.registrationPage.profileInfo.logo.altText = this.sharedService.emptyStringHandler(data['registration-page'].profileInfo?.logo?.altText);
		this.state.registrationPage.profileInfo.phoneNumber = this.sharedService.emptyStringHandler(data['registration-page'].profileInfo?.phoneNumber);
		this.state.registrationPage.profileInfo.requestedRole.description = this.sharedService.emptyStringHandler(data['registration-page'].profileInfo?.requestedRole?.description);
		this.state.registrationPage.profileInfo.requestedRole.label = this.sharedService.emptyStringHandler(data['registration-page'].profileInfo?.requestedRole?.label);
		this.state.registrationPage.profileInfo.requestedRoleAltText = this.sharedService.emptyStringHandler(data['registration-page'].profileInfo?.requestedRoleAltText);
		this.state.registrationPage.profileInfo.stepNumber = this.sharedService.emptyStringHandler(data['registration-page'].profileInfo?.stepNumber);
	}
	// eslint-disable-next-line complexity
	mapRegistrationPageTermsAndConditions(data:RegistrationResponse)
	{
		this.state.registrationPage.termsConditions.description = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.description);
		this.state.registrationPage.termsConditions.heading = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.heading);
		this.state.registrationPage.termsConditions.logo.altText = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.logo?.altText);
		this.state.registrationPage.termsConditions.logo.iconPath = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.logo?.iconPath);
		this.state.registrationPage.termsConditions.privacy.label = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.privacy?.label);
		this.state.registrationPage.termsConditions.privacy.modal.agreeButtonLabel = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.privacy?.modal?.agreeButtonLabel);
		this.state.registrationPage.termsConditions.privacy.infoBanner = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.privacy?.infoBanner ? this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.privacy?.infoBanner): TermsAndConditionPrivacyPolicyInfoBannerText.privacyPolicyInfoBannerText);
		this.state.registrationPage.termsConditions.privacy.modal.agreedButtonLabel = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.privacy?.modal?.agreedButtonLabel);
		this.state.registrationPage.termsConditions.privacy.modal.closeIcon.altText = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.privacy?.modal?.closeIcon?.altText);
		this.state.registrationPage.termsConditions.privacy.modal.closeIcon.iconPath = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.privacy?.modal?.closeIcon?.iconPath);
		this.state.registrationPage.termsConditions.privacy.modal.content = data['registration-page'].termsConditions?.privacy?.modal?.content?data['registration-page'].termsConditions?.privacy?.modal?.content:[];
		this.state.registrationPage.termsConditions.privacy.modal.disagreeButtonLabel = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.privacy?.modal?.disagreeButtonLabel);
		this.state.registrationPage.termsConditions.privacy.modal.heading = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.privacy?.modal?.heading);
		this.state.registrationPage.termsConditions.privacy.modal.checkboxText = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.privacy?.modal?.checkboxText);
		this.state.registrationPage.termsConditions.privacy.tokenData = data['registration-page'].termsConditions?.privacy?.tokenData?data['registration-page'].termsConditions?.privacy?.tokenData:[{ name: '', text: '', url: '', isLink: '' }];
		this.state.registrationPage.termsConditions.privacy.disclaimer = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.privacy?.disclaimer);
		this.state.registrationPage.termsConditions.stepNumber = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.stepNumber);
		this.state.registrationPage.termsConditions.terms.label = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.terms?.label);
		this.state.registrationPage.termsConditions.terms.modal.agreeButtonLabel = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.terms?.modal?.agreeButtonLabel);
		this.state.registrationPage.termsConditions.terms.infoBanner = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.terms?.infoBanner ? this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.terms?.infoBanner): TermsAndConditionPrivacyPolicyInfoBannerText.tandCInfoBannerText);
		this.state.registrationPage.termsConditions.terms.modal.agreedButtonLabel = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.terms?.modal?.agreedButtonLabel);
		this.state.registrationPage.termsConditions.terms.modal.closeIcon.altText = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.terms?.modal?.closeIcon?.altText);
		this.state.registrationPage.termsConditions.terms.modal.closeIcon.iconPath = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.terms?.modal?.closeIcon?.iconPath);
		this.state.registrationPage.termsConditions.terms.modal.content = data['registration-page'].termsConditions?.terms?.modal?.content?data['registration-page'].termsConditions?.terms?.modal?.content:[];
		this.state.registrationPage.termsConditions.terms.modal.disagreeButtonLabel = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.terms?.modal?.disagreeButtonLabel);
		this.state.registrationPage.termsConditions.terms.modal.heading = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.terms?.modal?.heading);
		this.state.registrationPage.termsConditions.terms.modal.checkboxText = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.terms?.modal?.checkboxText);
		this.state.registrationPage.termsConditions.terms.tokenData = data['registration-page'].termsConditions?.terms?.tokenData?data['registration-page'].termsConditions?.terms?.tokenData:[{ name: '', text: '', url: '', isLink: '' }];
		this.state.registrationPage.termsConditions.terms.disclaimer = this.sharedService.emptyStringHandler(data['registration-page'].termsConditions?.terms?.disclaimer);
	}
	mapRegistrationPagePrivacyPolicy(data:RegistrationResponse)
	{
		this.state.registrationPage.privacypolicy.description = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.description);
		this.state.registrationPage.privacypolicy.heading = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.heading);
		this.state.registrationPage.privacypolicy.logo.altText = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.logo?.altText);
		this.state.registrationPage.privacypolicy.logo.iconPath = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.logo?.iconPath);
		this.state.registrationPage.privacypolicy.privacy.label = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.privacy?.label);
		this.state.registrationPage.privacypolicy.privacy.infoBanner = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.privacy?.infoBanner);
		this.state.registrationPage.privacypolicy.privacy.modal.agreeButtonLabel = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.privacy?.modal?.agreeButtonLabel);
		this.state.registrationPage.privacypolicy.privacy.modal.agreedButtonLabel = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.privacy?.modal?.agreedButtonLabel);
		this.state.registrationPage.privacypolicy.privacy.modal.closeIcon.altText = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.privacy?.modal?.closeIcon?.altText);
		this.state.registrationPage.privacypolicy.privacy.modal.closeIcon.iconPath = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.privacy?.modal?.closeIcon?.iconPath);
		this.state.registrationPage.privacypolicy.privacy.modal.content = data['registration-page'].privacypolicy?.privacy?.modal?.content?data['registration-page'].privacypolicy?.privacy?.modal?.content:[];
		this.state.registrationPage.privacypolicy.privacy.modal.disagreeButtonLabel = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.privacy?.modal?.disagreeButtonLabel);
		this.state.registrationPage.privacypolicy.privacy.modal.heading = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.privacy?.modal?.heading);
		this.state.registrationPage.privacypolicy.privacy.modal.checkboxText = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.privacy?.modal?.checkboxText);
		this.state.registrationPage.privacypolicy.privacy.tokenData = data['registration-page'].privacypolicy?.privacy?.tokenData?data['registration-page'].privacypolicy?.privacy?.tokenData:[{ name: '', text: '', url: '', isLink: '' }];
		this.state.registrationPage.privacypolicy.stepNumber = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.stepNumber);
		this.state.registrationPage.privacypolicy.terms.label = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.terms?.label);
		this.state.registrationPage.privacypolicy.terms.modal.agreeButtonLabel = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.terms?.modal?.agreeButtonLabel);
		this.state.registrationPage.privacypolicy.terms.modal.agreedButtonLabel = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.terms?.modal?.agreedButtonLabel);
		this.state.registrationPage.privacypolicy.terms.modal.closeIcon.altText = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.terms?.modal?.closeIcon?.altText);
		this.state.registrationPage.privacypolicy.terms.modal.closeIcon.iconPath = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.terms?.modal?.closeIcon?.iconPath);
		this.state.registrationPage.privacypolicy.terms.modal.content = data['registration-page'].privacypolicy?.terms?.modal?.content?data['registration-page'].privacypolicy?.terms?.modal?.content:[];
		this.state.registrationPage.privacypolicy.terms.modal.disagreeButtonLabel = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.terms?.modal?.disagreeButtonLabel);
		this.state.registrationPage.privacypolicy.terms.modal.heading = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.terms?.modal?.heading);
		this.state.registrationPage.privacypolicy.terms.modal.checkboxText = this.sharedService.emptyStringHandler(data['registration-page'].privacypolicy?.terms?.modal?.checkboxText);
		this.state.registrationPage.privacypolicy.terms.tokenData = data['registration-page'].privacypolicy?.terms?.tokenData?data['registration-page'].privacypolicy?.terms?.tokenData:[{ name: '', text: '', url: '', isLink: '' }];
	}
	mapRegistrationPageAdditionalLocation(data:RegistrationResponse)
	{
		this.state.registrationPage.additionalLocation.locationPageDescription.description1 = this.sharedService.emptyStringHandler(data['registration-page'].additionalLocation?.locationPageDescription?.description1);
		this.state.registrationPage.additionalLocation.locationPageDescription.description2 = this.sharedService.emptyStringHandler(data['registration-page'].additionalLocation?.locationPageDescription?.description2);
		this.state.registrationPage.additionalLocation.locationPageDescription.tokenData = data['registration-page'].additionalLocation?.locationPageDescription?.tokenData?data['registration-page'].additionalLocation?.locationPageDescription?.tokenData:[{ name: '', text: '', url: '', isLink: '' }];
		this.state.registrationPage.additionalLocation.heading1 = this.sharedService.emptyStringHandler(data['registration-page'].additionalLocation?.heading1);
		this.state.registrationPage.additionalLocation.headingOr = this.sharedService.emptyStringHandler(data['registration-page'].additionalLocation?.headingOr);
		this.state.registrationPage.additionalLocation.heading2.label = this.sharedService.emptyStringHandler(data['registration-page'].additionalLocation?.heading2?.label);
		this.state.registrationPage.additionalLocation.heading2.iconPath = this.sharedService.emptyStringHandler(data['registration-page'].additionalLocation?.heading2?.iconPath);
		this.state.registrationPage.additionalLocation.heading2.altText = this.sharedService.emptyStringHandler(data['registration-page'].additionalLocation?.heading2?.altText);
		this.state.registrationPage.additionalLocation.logo.iconPath = this.sharedService.emptyStringHandler(data['registration-page'].additionalLocation?.logo?.iconPath);
		this.state.registrationPage.additionalLocation.logo.altText = this.sharedService.emptyStringHandler(data['registration-page'].additionalLocation?.logo?.altText);
		this.state.registrationPage.additionalLocation.stepNumber = this.sharedService.emptyStringHandler(data['registration-page'].additionalLocation?.stepNumber);
		this.state.registrationPage.additionalLocation.primaryLocationHeading = this.sharedService.emptyStringHandler(data['registration-page'].additionalLocation?.primaryLocationHeading);
		this.state.registrationPage.additionalLocation.selectLocationTableHeader.companyName = this.sharedService.emptyStringHandler(data['registration-page'].additionalLocation?.selectLocationTableHeader?.companyName);
		this.state.registrationPage.additionalLocation.selectLocationTableHeader.address = this.sharedService.emptyStringHandler(data['registration-page'].additionalLocation?.selectLocationTableHeader?.address);
		this.state.registrationPage.additionalLocation.selectLocationTableHeader.country = this.sharedService.emptyStringHandler(data['registration-page'].additionalLocation?.selectLocationTableHeader?.country);
		this.state.registrationPage.additionalLocation.selectLocationTableHeader.selectAll = this.sharedService.emptyStringHandler(data['registration-page'].additionalLocation?.selectLocationTableHeader?.selectAll);
		this.state.registrationPage.additionalLocation.uploadSuccessText = this.sharedService.emptyStringHandler(data['registration-page'].additionalLocation?.uploadSuccessText);
		this.state.registrationPage.additionalLocation.uploadSuccessSubtext = this.sharedService.emptyStringHandler(data['registration-page'].additionalLocation?.uploadSuccessSubtext);
	}
	mapDomainAemLabels(data:RegistrationResponse)
	{
		this.state.registrationPage.domainInfo.heading = this.sharedService.emptyStringHandler(data['registration-page'].domainInfo?.heading);
		this.state.registrationPage.domainInfo.description = this.sharedService.emptyStringHandler(data['registration-page'].domainInfo?.description);
		this.state.registrationPage.domainInfo.subHeading = this.sharedService.emptyStringHandler(data['registration-page'].domainInfo?.subHeading);
		this.state.registrationPage.domainInfo.stepNumber = this.sharedService.emptyStringHandler(data['registration-page'].domainInfo?.stepNumber);
		this.state.registrationPage.domainInfo.logo.iconPath = this.sharedService.emptyStringHandler(data['registration-page'].domainInfo?.logo?.iconPath);
		this.state.registrationPage.domainInfo.logo.altText = this.sharedService.emptyStringHandler(data['registration-page'].domainInfo?.logo?.altText);
		this.state.registrationPage.domainInfo.labelPrefix = this.sharedService.emptyStringHandler(data['registration-page'].domainInfo?.labelPrefix);
		this.state.registrationPage.domainInfo.labelSuffix = this.sharedService.emptyStringHandler(data['registration-page'].domainInfo?.labelSuffix);
	}
	mapAdditionalAemLabels()
	{
		this.state.verifyInformationButton.label = 'Verify Information';
		this.state.modifyDetailsButton.label = 'Modify Details';
		this.state.submitButton.label = 'Submit Registration';
		if(this.isRaymond)
			this.state.continueButton.label = 'Next';
		else
			this.state.continueButton.label = 'Continue';
		this.state.vertexAPIValidationLabels = RegistrationMappingFactory.mapVertexLabels();
		this.state.mapVertexAddressFailedLabels = RegistrationMappingFactory.mapVertexAddressFailedLabels();
		this.state.mapVerifyRoleLabels = RegistrationMappingFactory.mapVerifyRoleLabels();
		this.state.registrationPage.companyError.actionMessage = 'Please update your information below or request access from MyToyota Customer Service.';
		this.state.registrationPage.companyError.phoneNumber = { label: 'Call / Text', value: '1.844.965.0182' };
		this.state.registrationPage.companyError.email = { label: 'Email', value: 'customerservice@toyotatmh.com' };
		this.state.registrationPage.companyError.customerServiceName = 'MyToyota Customer Service';
		this.state.contactDealerButton.label = 'Contact Us';
		this.state.errorText = RegistrationMappingFactory.mapFieldErrorText();
		this.state.ribbonClearButton.label = 'Clear All';
		this.state.additionalLocationSubmitButton.label = 'Submit';
	}
	public getGoogleTranslatePanel(renderer: Renderer2): HTMLIFrameElement | null
	{
		try
		{
			return renderer.selectRootElement('div.skiptranslate > iframe');
		}
		catch (error)
		{
			this.loggerService.log('trying to select google translate panel', error);
			return null;
		}
	}
	public performFirstTimeTranslation(selection: string, renderer: Renderer2): void
	{
		const googleTranslateMenuLink: HTMLAnchorElement = renderer.selectRootElement('#google_translate_element a');
		renderer.removeAttribute(googleTranslateMenuLink, 'href');
		renderer.selectRootElement(googleTranslateMenuLink).click();
		const iframeElList: NodeListOf<HTMLIFrameElement> = document.querySelectorAll('iframe.skiptranslate');
		const foundLink: unknown = Array.from(iframeElList).find((item: HTMLIFrameElement) =>
		{
			const links: NodeListOf<HTMLAnchorElement> | undefined = item.contentWindow !== null ? item.contentWindow.document.querySelectorAll('a') : undefined;
			const link: HTMLAnchorElement | undefined = links !== undefined ? Array.from(links).find(thisLink => lodashGet(thisLink, 'value') === selection) : undefined;
			link !== undefined ? renderer.selectRootElement(link).click() : (() => {} )();
			return link !== undefined;
		});
		this.loggerService.log('found translation link and stopped', foundLink);
	}
	public performSubsequetTranslation(panelAfterFirstTranslation: HTMLIFrameElement, selection: string): void
	{
		const buttonRestore: HTMLButtonElement | null = (panelAfterFirstTranslation.contentWindow as {document: Document}).document.getElementById(':2.restore') as HTMLButtonElement || null;
		const buttonTranslate: HTMLButtonElement | null = (panelAfterFirstTranslation.contentWindow as {document: Document}).document.getElementById(':2.confirm') as HTMLButtonElement || null;
		selection === 'en' ? (buttonRestore).click() : (buttonTranslate).click();
	}
	async canActivatePortal()
	{
		const status: ApiResponse = await this.getUserRegistrationStatus();
		const responseObject = <UserRegistrationStatus>status.data;
		if(responseObject.hasOwnProperty('registrationStatus') && responseObject.registrationStatus !== undefined)
		{
			responseObject.registrationStatus = responseObject.registrationStatus === 'pending_approval' && responseObject.orgAdminPending? 'pending_business_approval' : responseObject.registrationStatus;
			this.redirectBasedOnRegistrationStatus(responseObject.registrationStatus);
		}
	}
	saveGeneralUser()
	{
		this.apiService.saveGeneralUser().subscribe({
			next: (response: ApiResponse) =>
			{
				if(response.data && response.statusCode === 201)
				{
					const responseObject = <UserRegistrationStatus>response.data;
					this.isRegistrationStatusPresent(responseObject);
				}
			},
			error: (error: HttpErrorResponse) =>
			{
				this.handleCommonError(error.error.message);
			}
		});
	}
	isRegistrationStatusPresent(responseObject: UserRegistrationStatus)
	{
		if(responseObject.hasOwnProperty('registrationStatus') && responseObject.registrationStatus !== undefined)
		{
			responseObject.registrationStatus = responseObject.registrationStatus === 'pending_approval' && responseObject.orgAdminPending? 'pending_business_approval' : responseObject.registrationStatus;
			this.redirectBasedOnRegistrationStatus(responseObject.registrationStatus);
		}
	}
	saveIndividualUser()
	{
		this.apiService.saveIndividualUser().subscribe({
			next: (response: ApiResponse) =>
			{
				this.isSavingIndividualUser = true;
				if(response.data && response.statusCode === 201)
				{
					const responseObject = <UserRegistrationStatus>response.data;
					if(responseObject.hasOwnProperty('registrationStatus') && responseObject.registrationStatus !== undefined)
					{
						this.redirectBasedOnRegistrationStatus(responseObject.registrationStatus);
					}
				}
			},
			error: (error: HttpErrorResponse) =>
			{
				this.handleCommonError(error.error.message);
			}
		});
	}
	handleCommonError(message: string)
	{
		this.state.loading = false;
		this.toaster.error(message);
		const analyticsData: AnalyticsDataLayer = {
			event: 'Submit Registration Failed',
			error: { message: message }
		};
		this.analyticsService.trackRegistrationByEvent(analyticsData, this.state.email);
	}
	redirectBasedOnRegistrationStatus(registrationStatus: UserRegistrationStatusValue)
	{
		this.isContinueSuccess = false;
		if(registrationStatus === 'in_progress')
		{
			this.isContinueSuccess = true;
		}
		const routingFunction: RoutingFunction | undefined = this.sharedUtilService.statusValueToRedirectsMap.get(registrationStatus);
		if (routingFunction !== undefined)
		{
			routingFunction(this.router)?.then(succeeded =>
			{
				if (succeeded)
				{
					this.loggerService.log('navigation succeeded');
				}
			})
				.catch(error =>
				{
					this.loggerService.error(error);
				});
		}
	}
	private async getUserRegistrationStatus(): Promise<ApiResponse>
	{
		try
		{
			return await this.apiService.getUserRegistrationStatus();
		}
		catch (error)
		{
			this.loggerService.log('Error redirecting to logout', error);
			throw error;
		}
	}
	getAdditionalLocationList()
	{
		this.state.additionalLocationSubmitButton.disabled = false;
		this.state.loading = true;
		this.apiService.getAdditionalLocations().subscribe({
			next: (res: ApiResponse) =>
			{
				if (res?.data)
				{
					const responseObj: AdditionalLocationListResponse = <AdditionalLocationListResponse>res.data;
					if(responseObj.pendingLocationDetails)
					{
						this.isUploadSuccess = true;
					}
					this.state.additionalLocationList = this.registrationUtilService.mapAdditionalLocationList(this.state.additionalLocationList, responseObj);
					this.additionalLocations = responseObj.locationList;
					const locations: GridData[] = this.registrationUtilService.formatLocationList(responseObj.locationList);
					this.state.additionalLocationGrid = [...locations];
					this.checkForSelectAll();
					this.isPrimaryLocationPresent = this.registrationUtilService.isPrimaryLocationAvailable(responseObj);
					if(this.state.additionalLocationGrid.length === 0)
					{
						this.state.additionalLocationError = {
							message: 'No additional locations were found with your Company Details.',
							messageSubText: 'Please press "Submit" to complete your Enterprise Account registration for your Primary Location only or upload a list of additional locations by clicking the link above.',
							icon: Icons.noResult
						};
					}
				}
			},
			error: (err) =>
			{
				this.state.loading = false;
				this.state.additionalLocationGrid = [];
				this.state.additionalLocationError = {
					message: 'Unable to load list of locations, please try again later.',
					messageSubText: '',
					icon: Icons.apiIssue
				};
				this.state.additionalLocationSubmitButton.disabled = true;
				this.trackAnalyticsOnListFailure();
				throw err;
			},
			complete: () =>
			{
				setTimeout(() =>
				{
					this.state.loading = false;
					this.state.additionalLocationSubmitButton.disabled = false;
				}, 1000);
			}
		});
	}
	trackAnalyticsOnListFailure()
	{
		const analyticsData: AnalyticsDataLayer = {
			event: 'Additional Locations List Failed',
			error: {
				message: 'Unable to load list of locations, please try again later.'
			}
		};
		this.analyticsService.trackRegistrationByEvent(analyticsData, this.state.email);
	}
	checkForSelectAll(): void
	{
		if(this.state.additionalLocationGrid.length === 0)
		{
			this.checkAll = false;
		}
	}
	trackAnalyticsDataOnSubmit()
	{
		const analyticsData: AnalyticsDataLayer = {
			event: 'Submit Registration',
			link: {
				name: 'Submit Registration button'
			}
		};
		this.analyticsService.trackRegistrationByEvent(analyticsData, this.state.email);
	}
	submitAdditionalLocation(selectedLocationGrids: string[], claimDomain: boolean = false)
	{
		let payload: SubmitBusinessPayload = {
			selectedLocationList: [],
			selectionMethod: 'manual',
			claimDomain: false
		};
		payload = this.registrationUtilService.submitLocationPayload(this.isUploadSuccess, this.additionalLocations, selectedLocationGrids);
		payload.claimDomain = claimDomain;
		this.apiService.submitAdditionalLocation(payload)
			.subscribe({
				next: (res: ApiResponse) =>
				{
					this.handleSuccessForBusinessAccount(res);
				},
				error: (error: HttpErrorResponse) =>
				{
					if(error.status === 504)
						this.handleCommonError(ErrorMessage.registration504Error);
					else
						this.handleCommonError(error.error.message);
				}
			});
	}
	handleSuccessForBusinessAccount(response: ApiResponse)
	{
		if (response.data)
		{
			this.trackAnalyticsDataOnSubmit();
			this.isSavingIndividualUser = true;
			const responseObj: SubmitRegistrationResponse = <SubmitRegistrationResponse>response.data;
			this.registrationUtilService.isBusinessAccountRegistration(responseObj);
			if(this.isRaymond && this.isContinueButton)
			{
				localStorage.setItem('isRaymondAdminUser', 'true');
				this.router.navigate([ApplicationPath.pendingBusinessApproval]);
			}
			else
			{
				this.router.navigate([ApplicationPath.dashboard]);
			}
		}
	}
	saveBusinessUser()
	{
		this.state.loading = true;
		this.apiService.saveBusinessUser().subscribe({
			next: (res: ApiResponse) =>
			{
				this.handleSuccessForSaveBusinessUser(res);
			},
			error: (err) =>
			{
				this.state.loading = false;
				this.toaster.error(err.error.message);
			}
		});
	}
	handleSuccessForSaveBusinessUser(response: ApiResponse)
	{
		if (response.data)
		{
			const responseObj: SaveBusinessAccountResponse = <SaveBusinessAccountResponse>response.data;
			this.isStatusInProgress(responseObj.registrationStatus);
			this.sharedService.scrollToTopOfPage();
		}
	}
	isStatusInProgress(registrationStatus: UserRegistrationStatusValue)
	{
		if(registrationStatus === RegistrationStatus.inProgress)
		{
			this.redirectBasedOnRegistrationStatus(RegistrationStatus.inProgress);
		}
	}
	public getBusinessRegistrationFlowSubmitModalLabels()
	{
		this.apiService.getBusinessRegistrationFlowSubmitModalLabels().subscribe((res: BusinessRegistrationFlowSubmitModalLabels) =>
		{
			if (res)
			{
				this.state.businessRegistrationFlowSubmitModalLabels.heading = res.heading;
				this.businessRegistrationFlowSubmitModalState.buttons[0].label = res.cancel;
				this.businessRegistrationFlowSubmitModalState.buttons[1].label = res.proceed;
			}
		});
	}
	getBusinessRegistrationLocationDownload()
	{
		this.downloadButtonState.disabled = true;
		this.apiService.getBusinessRegistrationLocationDownload().subscribe({
			next: (res) =>
			{
				this.sharedService.downloadExcel(FileName.userLocationListUploadTemplate, res);
				this.downloadButtonState.disabled = false;
				this.downloadTemplateError = false;
				this.analyticsService.trackRegistrationByEvent({
					event: 'Download Success',
					link: {
						name: 'Download Template Button'
					},
					download: {
						fileName: FileName.userLocationListUploadTemplate+'.xlsx',
						fileType: 'Download Template'
					}
				}, this.state.email);
			},
			error: (error: HttpErrorResponse) =>
			{
				this.downloadTemplateError = true;
				this.registrationUtilService.handleDownloadCommonError(error, this.state, this.downloadButtonState, this.state.email);
				this.toaster.error(error.error.message);
			}
		});
	}
	getBusinessRegistrationUploadListModalLabels()
	{
		this.apiService.getBusinessRegistrationUploadListModalLabels().subscribe((res:RegistrationState ) =>
		{
			if (res?.uploadFileSection)
			{
				this.state.uploadFileSection.heading = this.sharedService.nullValueHandler(res.uploadFileSection.heading);
				this.state.uploadFileSection.subHeading = this.sharedService.nullValueHandler(res.uploadFileSection.subHeading);
				this.downloadButtonState.label =this.sharedService.nullValueHandler(res.uploadFileSection.download.downloadButton);
				this.state.uploadFileSection.upload=this.sharedService.nullValueHandler(res.uploadFileSection.upload);
				this.state.uploadFileSection.cancel=this.sharedService.nullValueHandler(res.uploadFileSection.cancel);
				this.state.uploadFileSection.close=this.sharedService.nullValueHandler(res.uploadFileSection.close);
				this.state.uploadFileSection.content = res.uploadFileSection.content;
				this.registrationUtilService.getUploadFileLabel(res, this.uploadFileState);
			}
		});
	}
	resetFileStateModel()
	{
		this.uploadFileState.isSuccessClient = true;
		this.uploadFileState.isSuccessServer = false;
		this.uploadFileState.isError = false;
		this.uploadFileState.errorHeading = '';
		this.uploadFileState.errorSubHeading = '';
	}
	checkServerValidationUploadFile(item: File)
	{
		this.uploadFileState.isLoading = true;
		this.businessRegistrationUploadListModalState.buttons[0].hidden = true;
		this.businessRegistrationUploadListModalState.buttons[1].hidden = true;
		this.businessRegistrationUploadListModalState.buttons[2].label = this.state.uploadFileSection.close;
		this.businessRegistrationUploadListModalState.buttons[2].hidden = false;
		this.businessRegistrationUploadListModalState.buttons[2].cssClass = CssClass.btnBlack;
		this.businessRegistrationUploadListModalState.buttons[2].disabled = true;
		this.downloadButtonState.disabled = true;
		const ele = document.getElementById('kng-modal-close');
		if(ele)
			ele.setAttribute('disabled', 'true');
		this.apiService.getBAUploadLocation(item).subscribe({
			next: (res: ApiResponse) =>
			{
				if (res?.data)
				{
					this.businessRegistrationUploadListModalState.buttons[0].hidden = true;
					this.businessRegistrationUploadListModalState.buttons[1].hidden = true;
					this.businessRegistrationUploadListModalState.buttons[2].label = this.state.uploadFileSection.close;
					this.businessRegistrationUploadListModalState.buttons[2].hidden = false;
					this.businessRegistrationUploadListModalState.buttons[2].disabled = false;
					this.businessRegistrationUploadListModalState.buttons[2].cssClass = CssClass.btnBlack;
					this.uploadFileState.isLoading = false;
					this.isUploadSuccess = true;
					this.uploadFileState.isError = false;
					this.uploadFileState.isSuccessClient = true;
					this.uploadFileState.isSuccessServer = true;
					if(ele)
						ele.removeAttribute('disabled');
					this.downloadButtonState.disabled = false;
					this.analyticsService.trackRegistrationByEvent({
						event: 'Upload Success',
						link: {
							name: 'Upload File'
						},
						upload: {
							fileName: item.name,
							fileType: 'Locations List'
						}
					}, this.state.email);
				}
			},
			error: (error: HttpErrorResponse): void =>
			{
				this.handleUploadLocationError(ele, error);
			},
			complete: () =>
			{
				setTimeout(() =>
				{
					this.uploadFileState.isLoading = false;
					this.isUploadSuccess = true;
				}, 1000);
			}
		});
	}
	handleUploadLocationError(ele: HTMLElement| null, error: HttpErrorResponse)
	{
		this.businessRegistrationUploadListModalState.buttons[0].hidden = false;
		this.businessRegistrationUploadListModalState.buttons[0].disabled = false;
		this.businessRegistrationUploadListModalState.buttons[0].label = this.state.uploadFileSection.cancel;
		this.businessRegistrationUploadListModalState.buttons[1].hidden = true;
		this.businessRegistrationUploadListModalState.buttons[2].hidden = true;
		this.uploadFileState.isLoading = false;
		this.isUploadSuccess = false;
		this.uploadFileState.isError = true;
		this.uploadFileState.isSuccessClient = true;
		this.uploadFileState.isSuccessServer = false;
		if(ele)
			ele.removeAttribute('disabled');
		this.downloadButtonState.disabled = false;
		if(error.error.statusCode === 400)
		{
			this.uploadFileState.isSuccessClient = false;
			this.uploadFileState.errorHeading = ErrorMessageHeading.uploadFailed;
			this.uploadFileState.errorSubHeading = ErrorMessageSubHeading.templateMismatch;
			this.analyticsService.trackRegistrationByEvent({
				event: 'Upload Error',
				error: {
					message: ErrorMessageSubHeading.templateMismatch
				}
			}, this.state.email);
		}
		else if(error.error.statusCode === 403 || 500)
		{
			this.uploadFileState.errorHeading = ErrorMessageHeading.uploadFailed;
			this.uploadFileState.errorSubHeading = ErrorMessageSubHeading.apiError;
			this.analyticsService.trackRegistrationByEvent({
				event: 'Upload Error',
				error: {
					message: ErrorMessageSubHeading.apiError
				}
			}, this.state.email);
		}
		else
		{
			this.uploadFileState.errorHeading = ErrorMessageHeading.uploadFailed;
			this.uploadFileState.errorSubHeading = error.error.message;
			this.analyticsService.trackRegistrationByEvent({
				event: 'Upload Error',
				error: {
					message: error.error.message
				}
			}, this.state.email);
		}
	}
	verifyDomainClaimed(email: string)
	{
		const payload = {
			name: email
		};
		this.apiService.verifyDomain(payload).subscribe({
			next: (res: ApiResponse) =>
			{
				const domainData = <string[]>res.data;
				if (domainData && domainData?.length > 0)
				{
					this.disableDomainClaim = true;
				}
			}
		});
	}

	showVerifyRoleModal(response: ApiResponse)
	{
		const data: DealerData = response.data as DealerData;
		if((data.requestType === UserType.businessAdminUser || data.requestType === UserType.individualUser ) && this.profileInformationForm.controls['requestedRole'].value !== companyAdminRoleId)
		{
			this.verifyRoleModalState.hidden = false;
			this.isRequestedRoleValid = false;
			this.state.loading = false;
		} 
		else 
		{
			this.isRequestedRoleValid = true;
		}

	}
}
